<div class="page-layout simple full-width">

    <!-- HEADER -->
    <div class="header p-24 pb-0" fxLayout="row" fxLayoutAlign="space-between center">

        <div fxLayout="column" fxLayoutAlign="center start" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
            <div class="h2 mt-5"> Productos </div>
        </div>

        <button [routerLink]="'/product-add'" mat-raised-button>
            <span>Crear nuevo!</span>
        </button>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content">

        <!-- CENTER -->
        <div class="center p-24 pb-56" fusePerfectScrollbar>



            <!-- CONTENT -->
            <div class="content">

                <div class="">
                    <mat-form-field appearance="outline" fxFlex="20%" fxFlex.xs="calc(100% - 70px)" fxFlex.lt-md="40%" class="pl-4">
                        <mat-label>Título</mat-label>
                        <input matInput name="search-title" [(ngModel)]="filterSearch" (keydown.enter)="onSearch()" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="20%" fxFlex.xs="calc(100% - 70px)" fxFlex.lt-md="40%" class="pl-4">
                        <mat-label>Codigo</mat-label>
                        <input matInput  name="search-code" [(ngModel)]="filterSearchCodigo" (keydown.enter)="onSearch()" />
                    </mat-form-field>


                    <button class="ml-4 btn-icon-search" mat-raised-button color="primary" (click)="onSearch()"><mat-icon aria-hidden="false" aria-label="Buscar">search</mat-icon></button>
                </div>

                <div class="container-table product-table">
                    <mat-table #table [dataSource]="dataItems.data" [@animateStagger]="{value:'50'}">

                        <ng-container *ngFor="let column of configColumns" [matColumnDef]="column.key">
                            <!-- TH -->
                            <mat-header-cell *matHeaderCellDef>{{ column.title }}</mat-header-cell>

                            <!-- TD -->
                            <mat-cell *matCellDef="let item">

                                <ng-container *ngIf="column.type == 'integer' || column.type == 'string'">
                                    <p [ngClass]="{'text-truncate': column.type == 'integer'}" class="{{ column.classes }}">{{ item[column.field_key] }}</p>
                                </ng-container>

                                <ng-container *ngIf="column.type == 'option'">
                                    <p class="{{ column.classes }}">{{ column.options[item[column.field_key]].title }}</p>
                                </ng-container>

                            </mat-cell>
                            
                            
                        </ng-container>

                        <ng-container [matColumnDef]="'category'">
                            <!-- TH -->
                            <mat-header-cell *matHeaderCellDef>Categoría</mat-header-cell>

                            <!-- TD -->
                            <mat-cell *matCellDef="let item">

                                <ng-container>
                                    <p class="">{{ item.category.title }}</p>
                                </ng-container>

                            </mat-cell>
                            
                            
                        </ng-container>
                        

                        <!-- Buttons Column -->
                        <ng-container matColumnDef="actions" stickyEnd>
                            <mat-header-cell *matHeaderCellDef></mat-header-cell>
                            <mat-cell *matCellDef="let item">
                                <div fxFlex="row" fxLayoutAlign="end center">

                                    <button mat-icon-button [matMenuTriggerFor]="moreMenu" aria-label="Acciones" (click)="$event.stopPropagation();">
                                        <mat-icon class="secondary-text">more_vert</mat-icon>
                                    </button>

                                    <mat-menu #moreMenu="matMenu">
                                        <button [routerLink]="'/product-related/' + item.id" mat-menu-item aria-label="related">
                                            <mat-icon>edit</mat-icon>
                                            <span>Relacionados</span>
                                        </button>
                                        <button [routerLink]="'/product-edit/' + item.id" mat-menu-item aria-label="edit">
                                                <mat-icon>edit</mat-icon>
                                                <span>Editar</span>
                                            </button>
                                        <button mat-menu-item aria-label="remove" [swal]="{ title: 'Eliminar ' + item.id, text: '¿Se encuentra seguro de eliminar?', type: 'warning', focusCancel: true, showCancelButton: true, confirmButtonText: 'Eliminar', cancelButtonText: 'Cancelar' }"
                                            (confirm)="onRemove(item)">
                                                <mat-icon>delete</mat-icon>
                                                <span>Eliminar</span>
                                            </button>
                                    </mat-menu>
                                </div>

                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let item; columns: displayedColumns;" class="item" (click)="openItem(item)" matRipple [@animate]="{value:'*',params:{y:'100%'}}">
                        </mat-row>
                    </mat-table>
                </div>


                <mat-card *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center">
                    <mat-progress-spinner color="primary" mode="indeterminate">
                    </mat-progress-spinner>
                </mat-card>

                <mat-paginator [length]="dataItems.total" [pageSize]="tableModel.itemPerPage" [pageSizeOptions]="[5, 10, 25, 100]" (page)="onPageChange($event)"></mat-paginator>

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CENTER -->

    </div>
    <!-- / CONTENT-->

</div>